import React from 'react';
import { Box, Button, TextField, Typography } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import SearchIcon from '@mui/icons-material/Search';
import useLicenseSx from '../hooks/useLicenseSx';

export default function LicensePageHeader({
  search,
  onSearchChange,
  onCreate,
  count,
  statusLabel,
}) {
  const styles = useLicenseSx();

  return (
    <Box sx={styles.pageHeader}>
      <Box>
        <Typography variant="h5" sx={styles.pageTitle}>
          License Management
        </Typography>
        <Typography variant="body2" sx={styles.pageSubtitle}>
          Manage global license plans by status — {statusLabel || 'active'}, draft, and archived
          {count > 0 ? ` · ${count} ${statusLabel?.toLowerCase() || 'active'} license${count === 1 ? '' : 's'}` : ''}
        </Typography>
      </Box>

      <Box sx={styles.headerActions}>
        <TextField
          size="small"
          placeholder="Search licenses..."
          value={search}
          onChange={(e) => onSearchChange(e.target.value)}
          sx={styles.searchField}
          InputProps={{
            startAdornment: <SearchIcon fontSize="small" sx={{ color: 'text.disabled', mr: 1 }} />,
          }}
        />
        <Button
          variant="contained"
          startIcon={<AddIcon />}
          onClick={onCreate}
          sx={styles.createButton}
        >
          Create License
        </Button>
      </Box>
    </Box>
  );
}
